module.exports = __webpack_public_path__ + "img/erp-logos_0026_neto.fb24ae1c.jpg";